import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/75 transition-opacity duration-500 animate-in fade-in">
      
      <div class="flex flex-col items-center gap-10 p-12 transition-all duration-500">
        
        <div class="relative w-36 h-36 flex items-center justify-center">
          
          <div class="absolute -inset-10 rounded-full bg-[radial-gradient(circle,rgba(44,150,138,0.35)_0%,transparent_60%)] animate-pulse-slow"></div>
          
          <div class="absolute inset-0 animate-spin-slow">
            
            <svg viewBox="0 0 100 100" class="w-full h-full">
              <defs>
                <linearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#0f426d" />
                  <stop offset="100%" stop-color="#2c968a" />
                </linearGradient>
              </defs>
              <circle cx="50" cy="50" r="46" fill="none" 
                      stroke="url(#spinnerGradient)" 
                      stroke-width="4" 
                      stroke-linecap="round" 
                      stroke-dasharray="180 300" />
            </svg>
          </div>

          <div class="absolute inset-[15%] bg-white dark:bg-white rounded-full shadow-[0_0_20px_rgba(44,150,138,0.5)] z-0 ring-1 ring-slate-200 dark:ring-white/20"></div>

          <div class="relative z-10 p-5">
            <img src="assets/images/logo-icon.svg" alt="FilaSaúde" 
                 class="w-16 h-16 object-contain">
          </div>
        </div>
        
        <div class="text-center">
          <h2 class="text-sm font-black text-white uppercase tracking-[0.5em] opacity-90 mb-4 ml-[0.5em] drop-shadow-md">
            Carregando
          </h2>
          
          <div class="flex items-center justify-center gap-3">
            <span class="w-1 h-1 rounded-full bg-primary-500 animate-bounce"></span>
            <span class="w-1 h-1 rounded-full bg-teal-500 animate-bounce" style="animation-delay: 0.1s"></span>
            <span class="w-1 h-1 rounded-full bg-primary-500 animate-bounce" style="animation-delay: 0.2s"></span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    @keyframes spin-slow {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    
    /* A animação agora roda lisa porque está afetando um gradiente comum, não um blur computado */
    @keyframes pulse-slow {
      0%, 100% { opacity: 0.3; transform: scale(0.9); }
      50% { opacity: 0.7; transform: scale(1.1); }
    }
    .animate-spin-slow {
      animation: spin-slow 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }
    .animate-pulse-slow {
      animation: pulse-slow 3s ease-in-out infinite; 
    }
  `]
})
export class LoadingOverlayComponent {
  theme = inject(ThemeService);
}
